import React from "react";
import { useNavigate } from "react-router-dom";
import { ApolloConsumer } from "@apollo/client";

// Custom.
import { EnhancedTable } from "@vocollege/components";
import Layout from "containers/Layout/Layout";
import {
  GET_GROUPS_ROLES,
  DELETE_GROUPS_ROLE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const GroupsRoles: React.FC = () => {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/groups/roles/${id}`);
  };
  return (
    <ApolloConsumer>
      {(client) => (
        <Layout>
          <EnhancedTable
            client={client}
            className="vo-global__top-bottom-space"
            title={I18n.get.group.labels.groupRoles}
            operations={{
              category: "groupsRoles",
              get: GET_GROUPS_ROLES,
              delete: DELETE_GROUPS_ROLE,
            }}
            columns={[
              { title: "ID", field: "id", width: 100 },
              { title: I18n.get.acl.labels.name, field: "name", width: 200 },
              { title: I18n.get.acl.labels.label, field: "label" },
            ]}
            addItem={editItem}
            editItem={editItem}
          />
        </Layout>
      )}
    </ApolloConsumer>
  );
};

export default GroupsRoles;
